module.exports = __webpack_public_path__ + "media/playerDead.0d9bb543.wav";